<elcia-dropdown
  (selectionChange)="onSelectionChange($event)"
  [control]="control()"
  [items]="paymentModes()"
  [label]="'customer.payment-mode' | translate"
  [textField]="'name'"
  [valueField]="'id'"
/>
